/* eslint-disable no-dupe-keys */
export default {
  activity_participation: {
    // 属性
    prop: {
      pictures: '活动图片',
      poster: '邀请海报图片',
      inviter: '邀请用户',
      invitee: '应邀用户',
      created_at: '参与时间'
    },
    // 列表页字段（search display也重用）
    columns: {
      activity: '活动',
      inviter: '邀请用户',
      invitee: '应邀用户',
      created_at: '参与时间',
      inviter_reward: '邀请人奖励',
      invitee_reward: '应邀人奖励'
    },
    // Enum的属性
    // 占位提示
    placeholder: {
      search_keyword: '请输入活动名'
    }
  }
}
